import strings from "../../../utils/Strings";
import "../styles/NeedHelpOverallProgressStyles.css";
import scrollicon from "../assets/needhelp/scrollIcon.png";
import { useEffect, useRef, useState } from "react";
import EngagementScoreImg from "../assets/needhelp/engagement.png";
import PendingItemImg from "../assets/needhelp/engamentcalender.png";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
// import JetIcon from "../../../features/inventory_dashboard/assets/jetIcon.png";
import { engagementCards } from "../data/interface/needHelpConstants";
import CustomTooltipNeedHelp from "../../../components/CustomToolTipComponentsNeedHelp";
import ScrollDownButton from "../assets/needhelp/downArrow.png";
import { RightModalProps } from "./DashboardNeedHelp";
import { ContentWrapper, QuestionHeader } from "./NeedHelpOverAllProgress";
import viewArrow from "../assets/arrow.png";

const DashboardNeedHelpEngagementScore: React.FC<RightModalProps> = ({
  isOpen,
  toggleModal,
}) => {
  const [activeQuestion, setActiveQuestion] = useState<
    null | "progress" | "pending"
  >(null);
  const [active2Question, setActive2Question] = useState<
    null | "progress" | "pending"
  >(null);
  const profileData = useSelector(
    (state: RootState) => state.profile.profileKeys,
  );
  const filteredCards = profileData.partner_institute
    ? engagementCards
    : engagementCards.filter((card) => card.buttonText === "Take Assessment");
  const containerRef = useRef<HTMLDivElement | null>(null);
  const pendingCardRef = useRef<HTMLDivElement | null>(null);
  const progressCardRef = useRef<HTMLDivElement | null>(null);
  // Scroll to top function
  const [isAtTop, setIsAtTop] = useState(false);

  // Scroll Up
  const scrollToTop = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  // Scroll Down
  const scrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  // Track container scroll
  useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current) {
        setIsAtTop(containerRef.current.scrollTop < 50);
      }
    };

    const current = containerRef.current;
    current?.addEventListener("scroll", handleScroll);

    return () => current?.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      ref={containerRef}
      style={{ overflow: "auto", height: "700px", marginBottom: "20px" }}
    >
      {/* First Question */}
      {activeQuestion === "progress" ? (
        <ContentWrapper
          question={strings.needHelp.engScoreQues1V2}
          onClose={() => {
            setActiveQuestion(null);
          }}
        >
          <div className="needhelpv2-overallprogressContainer">
            <div className="neddhelpv2-overallprogress-left-column">
              <div
                className="needhelpv2-needhelpOPcardtext"
                ref={progressCardRef}
              >
                <p>{strings.needHelp.engagementScoreTxtV2}</p>
              </div>
              <img
                src={EngagementScoreImg}
                style={{
                  height: "80%",
                  width: "100%",
                }}
              />
              {/* <div
                className="needhelpv2-needhelpOPcardtext"
                ref={progressCardRef}
              >
                <p>{strings.needHelp.engagementScoreTxt2V2}</p>
              </div> */}
            </div>
            {/* <div className="neddhelpv2-overallprogress-right-column">
              <img
                src={EngagementScoreImg}
                style={{
                  height: "300px",
                  width: "400px",
                }}
              />
            </div> */}
          </div>
        </ContentWrapper>
      ) : (
        <QuestionHeader
          text={strings.needHelp.engScoreQues1V2}
          onClick={() => setActiveQuestion("progress")}
        />
      )}
      {/* Second Question */}
      {active2Question === "pending" ? (
        <ContentWrapper
          question={strings.needHelp.engScoreQues2V2}
          onClose={() => setActive2Question(null)}
        >
          <div className="needhelpv2-overallTopprogressContainer">
            {/* <div className="neddhelp-overallprogress-left-column"> */}
            <div className="needhelpv2-needhelpOPcardtext" ref={pendingCardRef}>
              <p>{strings.needHelp.engagementboostScoreTxtV2}</p>
              <img
                src={PendingItemImg}
                style={{ height: "25%", width: "100%" }}
              />
              {/* <p>
                {
                  strings.needHelp.engagementboostScoreTxt.split(
                    `"Boost Your Score"`,
                  )[0]
                }
                <CustomTooltipNeedHelp
                  title={
                    <div
                      // className="dash-overAllViewTab"
                      style={{
                        backgroundColor: "#395B9C",
                        height: "40px",
                        width: "100%",
                        borderRadius: "24px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: "500",
                        padding: "10px",
                        // cursor: "pointer",
                        fontFamily: "MazzardMedium",
                      }}
                      onClick={() => {}}
                    >
                      Level Up Your Engagement{" "}
                      <img
                        src={viewArrow}
                        alt="view"
                        style={{
                          height: "20px",
                          width: "20px",
                          marginLeft: "5px",
                        }}
                      />
                    </div>
                  }
                 
                >
                  <span
                    style={{
                      backgroundColor: "#9FDCEE",
                      cursor: "pointer",
                      padding: "2px 6px",
                      borderRadius: "4px",
                    }}
                  >
                    "Level Up Your Engagement"
                  </span>
                </CustomTooltipNeedHelp>
                {
                  strings.needHelp.engagementboostScoreTxt.split(
                    `"Boost Your Score"`,
                  )[1]
                }
              </p>{" "} */}
            </div>
            {/* </div> */}
            {/* <div className="neddhelp-overallprogress-right-column">
              <img
                src={PendingItemImg}
                style={{ height: "300px", width: "500px" }}
              />
            </div> */}
          </div>
          {/* <br />
          <div
            style={{
              borderRadius: "8px",
              backgroundColor: "#ffffff",
              padding: "20px",
              boxShadow: "0px 4px 24px 0px #00000040",
            }}
          >
            <div className="engagementHeader">
              <h2 className="engagementHeader-title">
                {strings.needHelp.levelTxt}
              </h2>
              <p className="engagementHeader-subtext">
                {strings.needHelp.levelSubTxt}
              </p>
            </div>
            <div className="dashboard-divider" />
            <div
              className="engagement-card-container"
              style={{
                display: "flex",
                gap: "16px",
                justifyContent: "flex-start",
                flexWrap: "wrap",
              }}
            >
              <div className="needhelpv2-overallprogressContainer">
                <div className="needhelpv2pending-overallprogress-left-column">
                  <img
                    src={PendingItemImg}
                    style={{ height: "400px", width: "500px" }}
                  />
                </div>
                <div className="needhelpv2pending-overallprogress-right-column">
                  <div className="needHelp-engagementDetail-container">
                    {filteredCards.map((card, index) => (
                      <div
                        key={index}
                        className="needHelp-engagementDetail-card"
                        style={{
                          backgroundColor: card.bgColor,
                          flex: "1",
                        }}
                      >
                        <div className="needHelp-engagementDetail-card-header">
                          <img
                            src={card.imageSrc}
                            alt={card.title}
                            className="needHelp-engagementDetail-card-img"
                          />
                          <h3 className="needHelp-engagementDetail-card-title">
                            {card.title}
                          </h3>
                        </div>
                        <p className="needHelp-engagementDetail-card-desc">
                          {card.description}
                        </p>
                        <button
                          className="needHelp-engagementDetail-card-btn"
                          style={{ cursor: "none" }}
                          onClick={async () => {}}
                        >
                          {card.buttonText}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </ContentWrapper>
      ) : (
        <QuestionHeader
          text={strings.needHelp.engScoreQues2V2}
          onClick={() => setActive2Question("pending")}
        />
      )}
      {isOpen && (
        <div
          onClick={isAtTop ? scrollToBottom : scrollToTop}
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            backgroundColor: "#B8BDc7",
            color: "#333333",
            fontWeight: 500,
            fontSize: "13px",
            boxShadow: "0px 1px 5px 0px #00000040",
            width: isAtTop ? "110px" : "100px",
            borderRadius: "18px",
            padding: "8px 8px",
            textAlign: "center",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            paddingLeft: 0,
            paddingRight: 0,
            zIndex: 9999, // ✅ ensures it's above other content
          }}
        >
          {isAtTop ? (
            <>
              Scroll down{" "}
              <img
                src={ScrollDownButton}
                alt="scroll-down"
                style={{ height: "20px", width: "20px" }}
              />
            </>
          ) : (
            <>
              Scroll up{" "}
              <img
                src={scrollicon}
                alt="scroll-up"
                style={{ height: "20px", width: "20px" }}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default DashboardNeedHelpEngagementScore;
